import { Select } from "components/base/Form";
import { SALES_BRIEF_WINDOW_TYPES } from "../constants";
import { formatDateTime } from "../utils";

const WindowCard = ({ windowType, onWindowTypeChange, updatedAt }) => {
  return (
    <div className="card flex flex-col lg:flex-row lg:items-center lg:justify-between gap-3">
      <div className="flex items-center gap-3">
        <div className="opacity-70">Window</div>
        <Select
          value={windowType}
          onChange={(event) => onWindowTypeChange(event.target.value)}
        >
          {SALES_BRIEF_WINDOW_TYPES.map(([value, label]) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
        </Select>
      </div>
      <div className="opacity-70">Updated: {formatDateTime(updatedAt)}</div>
    </div>
  );
};

export default WindowCard;
